import { PdfRequestDto } from '@@@/dto/api/PdfRequestDto';
import { PdfResponseDto } from '@@@/dto/api/PdfResponseDto';
import axios from 'axios';

const API_BASE = import.meta.env.VITE_API_BASE_URL as string;
const API_URL = `${API_BASE}`;

export default class PdfApiService {
    /**
     * Sends a PDF generation request to the backend.
     * @param payload - Already-localized questions and user answers.
     * @returns The PDF response data.
     */
    static async get(payload: PdfRequestDto): Promise<PdfResponseDto> {
        const response = await axios.post<PdfResponseDto>(`${API_URL}/blueprinthundred/pdf/create`, payload);
        return response.data;
    }
}
